'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function omitBy(obj, shouldOmit) {
    var result = {};
    var keys = Object.keys(obj);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var value = obj[key];
        if (!shouldOmit(value, key)) {
            result[key] = value;
        }
    }
    return result;
}
exports.omitBy = omitBy;
